<template>
  <div id="app" v-loading="loading">
    <router-view />
  </div>
</template>

<script>
import store from './store'
import V2NIM, { V2NIMConst } from 'nim-web-sdk-ng'
import { IMUIKit } from '@xkit-yx/im-kit-ui'
import localOptions from '@/config/imLocalOptions'

import { initIMUIKit } from "./components/NEUIKit/utils/init.js";
import { STORAGE_KEY } from "./components/NEUIKit/utils/constants";
import { showToast } from "./components/NEUIKit/utils/toast";
import RootStore from "./components/NEUIKit/utils/store";



export default {
  name: 'App',
  data() {
    return {
      loading: false,
      logoutMsg: null,
      audioContext: null,
      notificationSoundEnabled: false,
      showUiKit: false, // 控制是否显示IMUIKit
    }
  },
  async created() {
    // 页面刷新时恢复登录信息
    await store.dispatch('restoreLogin')
  },
  mounted() {
    console.log("process.env.VUE_APP_API_URL -------",process.env.VUE_APP_API_URL)
    console.log("2026-1-28---version:1.0.4")
    this.initNIM();

   
  },
  methods: {
    bootstrapContactUnreadAfterLogin(retry = 0) {
      const store = window.$uiKitStore
      if (!store || !store.friendStore || !store.teamStore) {
        if (retry < 40) {
          setTimeout(() => this.bootstrapContactUnreadAfterLogin(retry + 1), 50)
        }
        return
      }

      const tasks = []

      if (typeof store.friendStore.getAddApplicationListActive === 'function') {
        tasks.push(
          Promise.resolve()
            .then(() =>
              store.friendStore.getAddApplicationListActive({
                offset: 0,
                limit: 100,
              })
            )
            .catch(() =>
              store.friendStore.getAddApplicationListActive({
                status: [],
                offset: 0,
                limit: 100,
              })
            )
            .catch(() => {})
        )
      }

      if (typeof store.teamStore.getTeamJoinActionInfoListActive === 'function') {
        tasks.push(
          Promise.resolve()
            .then(() =>
              store.teamStore.getTeamJoinActionInfoListActive({
                offset: 0,
                limit: 100,
              })
            )
            .catch(() => {})
        )
      }

      Promise.all(tasks).catch(() => {})
    },

    init(opts) {
      const { nim } = initIMUIKit(opts.appkey);

      nim.V2NIMLoginService.login(opts.account, opts.token)
        .then(() => {
          if (this.$route.path !== "/chat") {
            this.$router.push("/chat");
          }
          this.showUiKit = true;
        })
        .catch((error) => {
          if (error.code === 102422) {
            // 账号被封禁
            showToast({
              message: "当前账号已被封禁",
              type: "info",
            });
          }
          // 登录信息无效，清除并跳转到登录页
          sessionStorage.removeItem(STORAGE_KEY);
          if (this.$route.path !== "/login") {
            this.$router.push("/login");
          }
        });
    },

    // 退出提示（防止重复）
    showLogoutMessage(msg) {
      if (this.logoutMsg) return
      this.logoutMsg = this.$message.info(msg)
      setTimeout(() => {
        this.logoutMsg = null
      }, 2000)
    },
    // 初始化 SDK
    initNIM() {
      if (window.$nim) return

      const instanceParam1 = {
        appkey: process.env.VUE_APP_IM_API_KEY,
         // 启用云端会话功能
        enableV2CloudConversation: true,// false
        debugLevel: 'error', //off error info debug
        apiVersion: 'v2',
      }
      const instanceParam2 = {
        V2NIMLoginServiceConfig: {
          lbsUrls: ['https://lbs.netease.im/lbs/webconf.jsp'],
          linkUrl: 'weblink.netease.im:443',
          // 多端登录配置 - 支持多台设备同时登录
          loginType: 1, // 1: 手动登录
          authType: 0, // 0: 静态token, 1: 动态token, 2: 第三方回调
          // 不强制踢出其他设备，允许多设备同时在线
          customClientType: 0, // 自定义客户端类型，0表示Web端
          // 重连配置
          retryCount: 5,
        },
      }

      try {
        const nim = V2NIM.getInstance(instanceParam1, instanceParam2)
        this.addEvent(nim)
        window.$nim = nim

        window.$uiKitStore = new RootStore(
            // @ts-ignore
            nim,
            {
              // 添加好友是否需要验证
              addFriendNeedVerify: false,
              // 是否需要显示 p2p 消息、p2p会话列表消息已读未读，默认 false
              p2pMsgReceiptVisible: true,
              // 是否需要显示群组消息已读未读，默认 false
              teamMsgReceiptVisible: true,
              // 群组被邀请模式，默认需要验证
              teamAgreeMode: V2NIMConst.V2NIMTeamAgreeMode.V2NIM_TEAM_AGREE_MODE_NO_AUTH,// 1 不需要检验
              // 是否展示群管理员
              teamManagerVisible: true,
              // 发送消息前回调, 可对消息体进行修改，添加自定义参数
              aiVisible: false,
              sendMsgBefore: async (options) => {
                return { ...options };
              },
            },
            "Web"
          );

        console.log("window.$uiKitStore", window.$uiKitStore)

        // 初始化 UIKit 实例
        window.$uikit = new IMUIKit({
          nim,
          singleton: true,
          localOptions,
          // 搜索功能配置
          searchConfig: {
            enableMessageSearch: true,
            enableConversationSearch: true,
            enableUserSearch: true,
            enableTeamSearch: true,
            searchMessageLimit: 100,
          }
        })
        console.log('NIM SDK 初始化完成')
        
        // 暴露测试方法到全局，方便调试
        window.testNotificationSound = () => {
          this.testNotificationSound()
        }
      } catch (err) {
        this.$message.error('NIM SDK 初始化失败')
        console.error('NIM SDK 初始化失败:', err)
      }
    },

    // 注册事件
    addEvent(nim) {
      nim.V2NIMLoginService.on('onLoginStatus', status => {
        console.log('登录状态变化:', status, typeof status)
        if (status === 2) {
          this.loading = true
          console.log('登录中...')
        } else if (status === 1) {
          this.loading = false
          this.$message.success('登录成功')
          console.log('登录成功，准备设置消息监听')
          // 登录成功后延迟一点再注册消息监听，确保SDK完全就绪
          setTimeout(() => {
            console.log('延迟后设置消息监听')
            this.setupMessageListener(nim)
            this.initAudioContext()
            this.bootstrapContactUnreadAfterLogin()
          }, 500)
        } else if (status === 0) {
          this.loading = false
          console.log('已退出登录')
          // 检查当前路由是否已经是登录页，如果不是才跳转
          if (this.$route.path !== '/login') {
            this.showLogoutMessage('您已退出登录,即将跳转到登录页')
            setTimeout(() => {
              this.$router.replace('/login').catch(() => {})
            }, 2000)
          }
        } else {
          this.loading = false
          console.log('其他登录状态:', status)
        }
      })

      nim.V2NIMLoginService.on('onDataSync', () => {
        setTimeout(() => {
          this.bootstrapContactUnreadAfterLogin()
        }, 50)
      })

      nim.V2NIMLoginService.on('onLoginFailed', status => {
        console.error('NIM 登录失败:', status)
        this.loading = false
        
        // 检查是否是 token 无效的错误
        const errorMsg = status?.error?.message || status?.message || ''
        if (errorMsg.includes('invalid token') || errorMsg.includes('token')) {
          this.$message.error('登录凭证无效，请重新登录')
          // 清除登录信息
          this.$store.commit('LOGOUT')
          // 跳转到登录页
          setTimeout(() => {
            this.$router.replace('/login').catch(() => {})
          }, 1500)
        } else {
          this.$message.error('登录失败: ' + (errorMsg || '未知错误'))
        }
      })

      nim.V2NIMLoginService.on('onDisconnected', status => {
        console.log('事件 onDisconnected:', status)
      })
      
      // 监听多端登录事件
      nim.V2NIMLoginService.on('onKickedOut', (data) => {
        console.log('被其他设备踢出:', data)
        const kickReason = data?.reason || '未知原因'
        // 注意：如果配置了允许多设备同时登录，通常不会触发此事件
        // 只有在云信控制台配置了互斥策略或达到设备数量限制时才会触发
        this.$message.warning({
          message: '您的账号在其他设备登录',
          description: `原因：${kickReason}`,
          duration: 5000,
          showClose: true
        })
        // 可选：不自动跳转，让用户决定是否重新登录
        // setTimeout(() => {
        //   this.$router.replace('/login').catch(() => {})
        // }, 2000)
      })
      
      // 监听其他设备登录事件 - 显示多设备在线状态
      nim.V2NIMLoginService.on('onOtherClientsLogin', (clients) => {
        console.log('其他设备登录:', clients)
        if (clients && clients.length > 0) {
          const deviceNames = {
            0: 'Web端',
            1: 'Windows端',
            2: 'iOS端',
            3: 'Android端',
            4: 'macOS端',
            5: 'Web小程序',
            6: 'HarmonyOS端'
          }
          
          const clientList = clients.map(c => {
            const deviceName = deviceNames[c.clientType] || `设备类型${c.clientType}`
            const loginTime = c.loginTime ? new Date(c.loginTime).toLocaleString() : '未知'
            return `${deviceName} - 登录时间: ${loginTime}`
          })
          
          this.$message.info({
            message: `当前账号在 ${clients.length} 台设备上在线`,
            description: clientList.join('\n'),
            duration: 5000,
            showClose: true
          })
        }
      })
    },

    // 设置消息监听
    setupMessageListener(nim) {
      try {
        console.log('========== 开始设置消息监听 ==========')
        console.log('nim对象:', nim)
        console.log('nim的所有属性:', Object.keys(nim))
        
        // 检查nim对象的所有服务
        const services = Object.keys(nim).filter(key => key.includes('Service') || key.includes('service'))
        console.log('找到的服务:', services)

        // console.log('V2NIMFriendService 的方法:', Object.keys(nim.V2NIMFriendService)) // 2026-1-15测试
        
        // 尝试多种方式监听消息
        // 方式1: V2NIMMessageService
        if (nim.V2NIMMessageService) {
          console.log('✓ 找到 V2NIMMessageService')
          console.log('V2NIMMessageService 的方法:', Object.keys(nim.V2NIMMessageService))
          
          // 尝试多种事件名称（注意：V2 版本使用复数形式 onReceiveMessages）
          const eventNames = [
            'onReceiveMessages',  // V2 版本的正确事件名（复数）
            'onReceiveMessage', 
            'onSendMessage',
            'onMessage', 
            'receiveMessage', 
            'onReceive', 
            'onTextMessage', 
            'onCustomMessage',

            "onmsg",// 回调收到占位消息。
            "onReceiveMessagesModified " // 回调持续收到分片消息，直到消息接收完毕。
          ]
          
          eventNames.forEach(eventName => {
            try {
              // 注意：不调用 off，避免移除 UIKit 的监听器
              // 只添加额外的监听器来播放提示音
              if (typeof nim.V2NIMMessageService.on === 'function') {
                nim.V2NIMMessageService.on(eventName, (messages) => {
                  console.log(`✓✓✓ [${eventName}] 收到新消息:`, messages)
                  // messages 可能是单个消息对象或消息数组
                  if (Array.isArray(messages)) {
                    // 如果是数组，为每条消息播放一次提示音（实际只播放一次）
                    if (messages.length > 0) {
                      this.playNotificationSound(messages[0])
                    }
                  } else {
                    // 如果是单个消息对象
                    this.playNotificationSound(messages)
                  }
                })
                console.log(`✓ 已注册事件监听: ${eventName}`)
              }
            } catch (err) {
              console.warn(`✗ 注册事件 ${eventName} 失败:`, err.message)
            }
          })
        } else {
          console.warn('✗ V2NIMMessageService 不可用')
        }
        
        // 方式2: 直接监听nim对象的事件
        try {
          if (typeof nim.on === 'function') {
            console.log('✓ nim对象支持 on 方法')
            const directEvents = ['onReceiveMessages', 'onReceiveMessage', 'onMessage', 'receiveMessage']
            directEvents.forEach(eventName => {
              try {
                // 注意：不调用 off，避免移除现有监听器
                nim.on(eventName, (messages) => {
                  console.log(`✓✓✓ [nim.${eventName}] 收到新消息:`, messages)
                  // 处理消息数组或单个消息
                  if (Array.isArray(messages)) {
                    if (messages.length > 0) {
                      this.playNotificationSound(messages[0])
                    }
                  } else {
                    this.playNotificationSound(messages)
                  }
                })
                console.log(`✓ 已注册直接事件监听: ${eventName}`)
              } catch (err) {
                // 忽略不支持的事件
                console.log(`- 事件 ${eventName} 不支持或已存在`)
              }
            })
          } else {
            console.warn('✗ nim对象不支持 on 方法')
          }
        } catch (err) {
          console.warn('✗ 直接监听nim事件失败:', err.message)
        }
        
        // 方式3: 通过UIKit监听（如果UIKit支持）
        if (window.$uikit) {
          console.log('✓ UIKit 可用')
          if (typeof window.$uikit.on === 'function') {
            try {
              window.$uikit.on('onReceiveMessage', (message) => {
                console.log('✓✓✓ [UIKit] 收到新消息:', message)
                this.playNotificationSound(message)
              })
              console.log('✓ 已注册UIKit消息监听')
            } catch (err) {
              console.warn('✗ UIKit消息监听失败:', err.message)
            }
          } else {
            console.warn('✗ UIKit 不支持 on 方法')
          }
        } else {
          console.warn('✗ UIKit 不可用')
        }
        
        console.log('========== 消息监听设置完成 ==========')
      } catch (error) {
        console.error('✗✗✗ 设置消息监听失败:', error)
      }
    },

    // 初始化音频上下文（需要在用户交互后调用）
    initAudioContext() {
      try {
        // 尝试初始化音频上下文，如果失败会在首次播放时重试
        if (window.AudioContext || window.webkitAudioContext) {
          // 不立即创建，等待首次播放时创建（避免浏览器限制）
          console.log('音频上下文将在首次播放时初始化')
        }
      } catch (error) {
        console.error('初始化音频上下文失败:', error)
      }
    },

    // 播放提示音
    playNotificationSound(message) {
      return console.log("no sound  --")
      try {
        if (!this.notificationSoundEnabled) return
        console.log('准备播放提示音，消息:', message)
        console.log('窗口状态 - hidden:', document.hidden, 'visibilityState:', document.visibilityState)
        
        // 临时简化：先确保能播放声音，方便调试
        // 后续可以根据需求优化逻辑
        console.log('直接播放提示音（调试模式）')
        this.playSound()
        
        // 原始逻辑（已注释，可根据需要启用）
        /*
        if (document.hidden) {
          // 窗口未激活，播放提示音
          console.log('窗口未激活，播放提示音')
          this.playSound()
        } else {
          // 窗口激活时，检查是否正在查看该会话
          // 如果当前会话不是收到消息的会话，也播放提示音
          const shouldPlay = this.shouldPlaySoundForMessage(message)
          console.log('窗口激活，是否播放:', shouldPlay)
          if (shouldPlay) {
            this.playSound()
          } else {
            console.log('跳过播放：消息属于当前会话')
          }
        }
        */
      } catch (error) {
        console.error('播放提示音失败:', error)
      }
    },
    
    // 测试提示音（可以在控制台调用 window.testNotificationSound() 来测试）
    testNotificationSound() {
      console.log('测试提示音播放')
      this.playSound()
    },

    // 判断是否应该播放提示音
    shouldPlaySoundForMessage(message) {
      try {
        // 如果UIKit可用，检查当前激活的会话
        if (window.$uikit && window.$uikit.getActiveSession) {
          const activeSession = window.$uikit.getActiveSession()
          if (!activeSession) {
            // 没有激活的会话，播放提示音
            return true
          }
          
          // 判断消息是否属于当前激活的会话
          const messageSessionId = this.getMessageSessionId(message)
          if (messageSessionId && messageSessionId !== activeSession) {
            // 消息不属于当前会话，播放提示音
            return true
          }
          
          // 消息属于当前会话，不播放提示音
          return false
        }
        
        // 无法判断，默认播放提示音
        return true
      } catch (error) {
        console.error('判断是否播放提示音失败:', error)
        return true
      }
    },

    // 获取消息的会话ID
    getMessageSessionId(message) {
      if (!message) return null
      
      // 根据消息类型构建会话ID
      if (message.scene === 'p2p') {
        // 单聊
        return `p2p-${message.from}`
      } else if (message.scene === 'team') {
        // 群聊
        return `team-${message.to}`
      }
      
      return null
    },

    // 播放声音
    playSound() {
      return console.log("no play---")
      try {
        console.log('开始播放声音')
        // 方法1: 使用Web Audio API生成提示音
        if (!this.audioContext) {
          try {
            console.log('创建音频上下文')
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
            console.log('音频上下文状态:', this.audioContext.state)
            // 如果上下文被暂停（浏览器限制），尝试恢复
            if (this.audioContext.state === 'suspended') {
              console.log('音频上下文被暂停，尝试恢复')
              this.audioContext.resume().then(() => {
                console.log('音频上下文已恢复')
                this.playOscillatorSound()
              }).catch((err) => {
                console.error('恢复音频上下文失败，使用备用方法:', err)
                // 如果恢复失败，使用备用方法
                this.playBeepSound()
                return
              })
              return
            }
          } catch (error) {
            console.error('创建音频上下文失败，使用备用方法:', error)
            this.playBeepSound()
            return
          }
        }
        
        // 确保上下文处于运行状态
        if (this.audioContext.state === 'suspended') {
          console.log('音频上下文被暂停，尝试恢复')
          this.audioContext.resume().then(() => {
            console.log('音频上下文已恢复，播放声音')
            this.playOscillatorSound()
          }).catch((err) => {
            console.error('恢复音频上下文失败:', err)
            this.playBeepSound()
          })
        } else {
          console.log('音频上下文正常，播放声音')
          this.playOscillatorSound()
        }
      } catch (error) {
        console.error('播放提示音失败，尝试备用方法:', error)
        // 备用方法：使用简单的beep音
        this.playBeepSound()
      }
    },

    // 使用振荡器播放声音
    playOscillatorSound() {
      return console.log("no play oscillator---")
      try {
        console.log('使用振荡器播放声音')
        const oscillator = this.audioContext.createOscillator()
        const gainNode = this.audioContext.createGain()
        
        oscillator.connect(gainNode)
        gainNode.connect(this.audioContext.destination)
        
        // 设置音调（1000Hz，更响亮清晰的通知音）
        oscillator.frequency.value = 1000;
        oscillator.type = 'sine'
        
        // 设置音量（最大音量：1.0，衰减更慢）
        gainNode.gain.setValueAtTime(1.0, this.audioContext.currentTime)
        gainNode.gain.exponentialRampToValueAtTime(0.1, this.audioContext.currentTime + 0.4)
        
        // 播放400毫秒（延长播放时间，让声音更明显）
        oscillator.start(this.audioContext.currentTime)
        oscillator.stop(this.audioContext.currentTime + 0.4)
        console.log('振荡器声音播放完成')
      } catch (error) {
        console.error('播放振荡器声音失败:', error)
        this.playBeepSound()
      }
    },

    // 备用播放方法：使用简单的beep音
    playBeepSound() {
      return console.log("no play beep sound---")
      try {
        console.log('使用备用方法播放beep音')
        // 创建一个简单的Audio元素播放提示音
        const audio = new Audio()
        // 使用data URI创建一个简短的beep音
        // 这里使用一个简单的正弦波音频数据
        const sampleRate = 44100
        const duration = 0.3  // 延长播放时间
        const frequency = 1000  // 提高频率，声音更响亮
        const samples = sampleRate * duration
        const buffer = new ArrayBuffer(44 + samples * 2)
        const view = new DataView(buffer)
        
        // WAV文件头
        const writeString = (offset, string) => {
          for (let i = 0; i < string.length; i++) {
            view.setUint8(offset + i, string.charCodeAt(i))
          }
        }
        
        writeString(0, 'RIFF')
        view.setUint32(4, 36 + samples * 2, true)
        writeString(8, 'WAVE')
        writeString(12, 'fmt ')
        view.setUint32(16, 16, true)
        view.setUint16(20, 1, true)
        view.setUint16(22, 1, true)
        view.setUint32(24, sampleRate, true)
        view.setUint32(28, sampleRate * 2, true)
        view.setUint16(32, 2, true)
        view.setUint16(34, 16, true)
        writeString(36, 'data')
        view.setUint32(40, samples * 2, true)
        
        // 生成音频数据（最大音量：振幅1.0，衰减更慢）
        for (let i = 0; i < samples; i++) {
          const t = i / sampleRate
          const sample = Math.sin(2 * Math.PI * frequency * t) * 1.0 * Math.exp(-t * 3)  // 振幅1.0，衰减更慢
          view.setInt16(44 + i * 2, sample * 0x7FFF, true)
        }
        
        const blob = new Blob([buffer], { type: 'audio/wav' })
        const url = URL.createObjectURL(blob)
        audio.src = url
        audio.volume = 1.0  // 最大音量
        
        // 添加事件监听
        audio.onplay = () => console.log('音频开始播放')
        audio.onended = () => {
          console.log('音频播放完成')
          URL.revokeObjectURL(url)
        }
        audio.onerror = (err) => console.error('音频播放错误:', err)
        
        audio.play().then(() => {
          console.log('音频播放成功')
        }).catch(err => {
          console.error('播放音频失败:', err)
        })
      } catch (error) {
        console.error('播放beep音失败:', error)
      }
    },
  },

  beforeDestroy() {
    if (window.$nim) {
      window.$nim.V2NIMLoginService.off('onLoginStatus')
      window.$nim.V2NIMLoginService.off('onLoginFailed')
      window.$nim.V2NIMLoginService.off('onDisconnected')
      window.$nim.V2NIMLoginService.off('onKickedOut')
      window.$nim.V2NIMLoginService.off('onOtherClientsLogin')
      
      // 取消消息接收监听
      if (window.$nim.V2NIMMessageService) {
        window.$nim.V2NIMMessageService.off('onReceiveMessage')
      }
    }
    
    // 清理音频上下文
    if (this.audioContext) {
      this.audioContext.close().catch(() => {})
      this.audioContext = null
    }
    
    this.$store.commit('LOGOUT')
  },
}
</script>

<style>
.el-badge__content.is-fixed {
  transform: translateY(-50%) translateX(50%) !important;
  /* background: gray !important; */
}
</style>
